import Demands from '@/views/demand/Demands.vue'
import demandModalRouter from '@/router/routers/demandModal'

const demandRouter = (beforeEnter) => {
    return {
        beforeEnter: beforeEnter,
        name: 'Demandas',
        path: '/demandas',
        meta: {
            requiresAuth: true,
            breadcrumb: true,
            breadcrumbName: 'Demandas',
            layout: 'default'
        },
        component: Demands,
        children: [
            demandModalRouter(beforeEnter, 'CadastrarDemanda', 'demandas', false),
            demandModalRouter(beforeEnter, 'DetalheDemanda', 'demandas', true)
        ]
    }
}

export default demandRouter
